import React from 'react'

import MediaAvatar from '../MediaAvatar'

import { arrayDifference } from '../../../utilities'
import { useUserAPI } from '../../../providers/UserAPIProvider'
import { useAddRemoveParticipant } from '../../../providers/AddRemoveParticipantProvider'
import useStyles from './styles'

const Participant = ({ users = [] }) => {
  const classes = useStyles()
  const { allUsers } = useUserAPI()
  const { addedUsers, setAddedUsers, setEditIDs } = useAddRemoveParticipant()

  const [combinedUsers, setCombinedUsers] = React.useState([])

  // initially setting existing user keys
  React.useEffect(() => {
    if (users.length && !combinedUsers.length) {
      const usersObj = users.map(id => {
        return { id: id, exists: true }
      })
      setCombinedUsers(usersObj)
    }
  }, [users, combinedUsers])

  // checking if user exists before adding it to list
  React.useEffect(() => {
    if (addedUsers?.length && combinedUsers.length) {
      // check if ids are in combined users
      const ids = addedUsers.map(u => u.id)

      const diff = arrayDifference(
        ids,
        combinedUsers.map(u => u.id)
      )

      setCombinedUsers(u => [
        ...u,
        ...addedUsers.filter(user => diff.includes(user.id))
      ])
    }
    // eslint-disable-next-line
  }, [addedUsers, users])

  // logic for removing users
  const handleRemove = React.useCallback(
    key => {
      // check if exist key in objects
      const user = combinedUsers.find(u => u.id === key)
      const idx = combinedUsers.indexOf(user)

      // add selected key value pair for color change
      if (user.exists) {
        user.selected = !user.selected
        if (idx > -1) {
          const ids = addedUsers.map(u => u.id)
          // const diff = arrayDifference(ids, combinedUsers)
          const diff = arrayDifference(
            ids,
            combinedUsers.map(u => u.id)
          )

          setCombinedUsers(u => [
            ...u,
            ...addedUsers.filter(user => diff.includes(user.id))
          ])
        }
      } else {
        // need to remove from added users list
        setAddedUsers(users => [...users.filter(user => user.id !== key)])
        setCombinedUsers(u => [...u.filter(user => user.id !== key)])
      }
    },
    [combinedUsers, addedUsers, setAddedUsers]
  )

  // updating users list to save to provider
  React.useEffect(() => {
    const newList = combinedUsers
      .filter(u => u.selected !== true)
      .map(u => u.id)

    setEditIDs(newList)
  }, [combinedUsers, setEditIDs])

  return (
    <div>
      {combinedUsers.map(user => {
        const isLoaded = !!allUsers[user.id]
        return (
          <div
            className={classes.root}
            key={user.id}
            style={{ opacity: user.selected ? '0.5' : '1' }}
          >
            <MediaAvatar
              key={user.id}
              user={allUsers[user.id]}
              showBadge
              badgeClass={classes.participants}
            />
            <div className={classes.name}>
              {!isLoaded ? 'Loading...' : allUsers[user.id]?.name}
            </div>
            {isLoaded && (
              <div
                className={classes.remove}
                onClick={() => handleRemove(user.id)}
              >
                {user.selected ? 'Cancel Remove' : 'Remove'}
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}

export default Participant
